export const version = '0.781.0'
export const chameleonWebVersion = '9.7.1'
export const chameleonCoreVersion = '7.8.0'
